import { render, staticRenderFns } from "./FlowView.vue?vue&type=template&id=242840c3&scoped=true"
import script from "./FlowView.vue?vue&type=script&lang=js"
export * from "./FlowView.vue?vue&type=script&lang=js"
import style0 from "./FlowView.vue?vue&type=style&index=0&id=242840c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242840c3",
  null
  
)

export default component.exports